import React from 'react';
import PropTypes from 'prop-types';
import isMobile  from "../helpers/useCheckMobileScreen";

/* eslint-disable react/no-set-state */
class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };

    this.link = this.props.link;
    this.closeWhenUnfocused = this.closeWhenUnfocused.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
  }

  closeWhenUnfocused() {
    this.handleClose();
    document.documentElement.removeEventListener('touchstart',
      this.closeWhenUnfocused,
      false);
  }

  handleClose() {
    this.setState({open: false});
  }

  handleOpen() {
    this.setState({open: true});
  }

  static handlePosition(c) {
    if (!c) return null;
    const rect = c.getBoundingClientRect();
    const { left } = rect;
    const width = c.offsetWidth;
    const vpWidth = window.innerWidth;
    let offset;

    if (vpWidth < width + left) {
      offset = width + left - vpWidth;
      c.style.marginLeft = `${(offset * -1)}px`; // eslint-disable-line no-param-reassign
    }
    return c;
  }

  handleToggle() {
    if (!this.state.open) {
      document.documentElement.addEventListener('touchstart',
        this.closeWhenUnfocused,
        false);
    }
    else {
      document.documentElement.removeEventListener('touchstart',
        this.closeWhenUnfocused,
        false);
    }

    this.setState({open: !this.state.open});
  }

  handleLinkClick(e) {
    if (this.link) {
      if (isMobile() && e.target.classList.contains('fa-info-circle')) {
        return;
      }
      window.open(this.link, '_blank')
    }
  }

  /* eslint-disable prefer-template */
  render() {
    return (
      <div className={'tooltip' + (this.state.open ? ' tooltip--expanded' : '') + (this.link ? ' tooltip--link' : '')}>
        <div
          onMouseLeave={this.handleClose}
          onMouseOver={this.handleOpen}
          onTouchEnd={this.handleToggle}
          onClick={this.handleLinkClick}
        >
        <div
          className="tooltip__trigger"
        >
          {this.props.trigger}
          {!this.props.trigger &&
            <i className="fa fa-info-circle" />
          }
        </div>
        {
          this.state.open && (
<div
  className="tooltip__body"
  ref={this.handlePosition}
  onTouchStart={this.handleLinkClick}
>
            {this.props.children}
</div>
          )}
      </div>
      </div>
    );
  }
}
/* eslint-enable react/no-set-state */
Tooltip.PropTypes = {
  children:PropTypes.node.isRequired,
  trigger:PropTypes.node,
};

export default Tooltip;
